import React, { FC, useState } from 'react';
import { BookingType, BookingFormType } from '../../redux/types/bookingTypes';
import styles from './CheckerboardBanner.module.scss';
import classNames from 'classnames';
import moment from 'moment';
import { TooltipIcon } from '../../assets/icons';
import BannerInner from './BannerInner';
import { useDispatch } from 'react-redux';
import { setModalWindowData } from '../../redux/reducers/pageSlice';
import { ModalWindowTypes } from '../../utils/@globalTypes';
import useWindowDimensions from '../../utils/useWindowDimensions';
import { setChessModalWindow } from '../../redux/reducers/bookingSlice';
import { getBookingBarGeometry } from '../../utils/functions/bookingTransitions';

type BannerProps = {
  booking: BookingType;
  cellWidth: number;
  type: 'start' | 'ending';
  currentDay: moment.Moment;
};

const CheckerboardBanner: FC<BannerProps> = ({
  booking,
  cellWidth,
  type,
  currentDay,
}) => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const diffLimit = 5;
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handlerViewBooking = () => {
    dispatch(
      setModalWindowData({
        type: ModalWindowTypes.SHOW_RESERVATION,
        data: { booking: booking, type: BookingFormType.view },
      }),
    );
  };
  const openModalWindow = () => {
    dispatch(
      setChessModalWindow({
        booking: booking,
        bookingClassName: bookingClassname,
      }),
    );
  };
  const today = new Date();

  const bookingClassname =
    moment(booking.check_out_date).startOf('day').unix() <
    moment(today).startOf('day').unix()
      ? 'last'
      : booking.status === 'awt'
        ? 'await'
        : +booking.accommodation_price +
              +booking.total_board_price +
              +booking.total_animal_price ===
            +booking.paid
          ? 'full_paid'
          : +booking.paid > 0
            ? 'part_paid'
            : 'not_paid';

  const {
    left: leftPosition,
    width: bannerWidth,
    durationDays,
  } = getBookingBarGeometry(booking, cellWidth, type, currentDay);

  const personLabel = `${booking.adult}+${booking.children ? booking.children.length : 0}`;

  if (durationDays < diffLimit) {
    return (
      <div
        className={styles.tooltipWrapper}
        style={{ width: bannerWidth, left: leftPosition }}
        onMouseLeave={() => setIsTooltipVisible(false)}
      >
        <div
          className={classNames(
            styles.container,
            styles[bookingClassname],
            styles.tooltip,
          )}
          style={{ width: bannerWidth, left: 0, top: 0 }}
          onClick={width > 932 ? handlerViewBooking : openModalWindow}
        >
          <div className={styles.tt_name}>
            {booking.last_name} {booking.first_name}
          </div>
          <div
            className={styles.tt_icon}
            onMouseEnter={() => setIsTooltipVisible(true)}
          >
            {personLabel}
            <TooltipIcon />
          </div>
        </div>
        <div
          className={classNames(
            styles.tt_full,
            isTooltipVisible && styles.tt_fullVisible,
          )}
        >
          <BannerInner
            booking={booking}
            bookingClassname={bookingClassname}
            bannerWidth={cellWidth * 4}
            left={0}
            isTooltip={true}
          />
        </div>
      </div>
    );
  }
  return (
    <BannerInner
      booking={booking}
      bookingClassname={bookingClassname}
      bannerWidth={bannerWidth}
      left={leftPosition}
      isTooltip={false}
    />
  );
};

export default CheckerboardBanner;
